<template>
  <div class="info-tile-item">
    <v-img :src="imgSrc" />
    <div class="button-tile-content">
      <h1 class="title-info">{{ title }}</h1>
      <p class="description">
        {{ description }}
      </p>
    </div>
  </div>
</template>

<script>

export default {
  name: "InfoTile",
  props: {
    imageUrl: {
      required: true,
      default: "",
      type: String,
    },
    title: {
      required: true,
      default: "",
      type: String,
    },
    description: {
      required: true,
      default: "",
      type: String,
    },
  },
  data() {
    return {
      imgSrc: null,
    };
  },
  created() {
    this.loadImage();
  },
  methods: {
    loadImage() {
      this.imgSrc = require(`@/assets/${this.imageUrl}`);
    },
  },
};
</script>

<style scoped lang="scss">
.info-tile-item {
  flex: 1;
  overflow: hidden;
  padding: 8px;
  display:flex;
  align-items: center;
  flex-direction: column;

  .v-image{
    max-width: 96px;
    max-height: 96px;
  }

  .button-tile-content {
    text-align: center;
    padding: 24px;
    padding-bottom: 31px;

    .title-info {
      font-family: Montserrat;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px;
      margin-bottom: 8px;
      color: var(--v-light-primary-text-colour-base, "#282828");
      letter-spacing: 0.024px;
    }
    .description {
      font-family: Montserrat;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
      color: var(--v-Onyx-base, #282828);
    }
  }
}
</style>
